'use client'

import {ModalBody, ModalHeader, ModalStyled} from "@/components/UI/Containers/Modal/Modal.styled";
import CloseIcon from "@/public/icons/x-rounded.svg";
import {useModal} from "@/hooks/useModal";
import {useEffect, useState} from "react";

const Modal = ({children, name, header, closable = true, mode = 'modal', closeIcon = <CloseIcon/>, hideClose= false, ...props}) => {
    const modal = useModal(name)
    const [initialRenderComplete, setInitialRenderComplete] = useState(false);

    useEffect(() => {
        setInitialRenderComplete(true);
    }, []);

    if (initialRenderComplete === false) return null;

    return (
        <ModalStyled
            key={modal.renderKey}
            open={modal.isOpen}
            onCancel={modal.hide}
            closeIcon={closeIcon}
            footer={null}
            destroyOnClose={true}
            maskClosable={closable}
            className={`popover-${mode}`}
            centered
            $hideClose={hideClose}
            {...props}
        >
            <ModalHeader>{header}</ModalHeader>
            <ModalBody>{children}</ModalBody>
        </ModalStyled>
    );
};

export default Modal;